import { defineFetcher } from "~/api/_common/defineFetcher"
import { POST } from "~/api/_common/http"

import { PostCourseApplication, PostCourseApplicationBody } from "../course-application/post"

const PATH = "/course-application-by-guest"

export type PostCourseApplicationByGuestBody = PostCourseApplicationBody & {
  name?: string | null
  phone_number?: string | null
  email?: string | null
}

export const fetchPostCourseApplicationByGuest = defineFetcher(
  (body?: PostCourseApplicationByGuestBody): Promise<PostCourseApplication> => {
    return POST(PATH, body)
  }
)
